<button
  class="nav-link dropdown-toggle"
  role="button"
  data-bs-toggle="dropdown"
  data-bs-display="dynamic"
  aria-expanded="false"
  >
  Reporting
</button>

<!--? Notice the dropdown structure in the mock UI is separated into nested unordered lists (why?). -->
<ul class="dropdown-menu dropdown-simple" style="min-width: 360px" data-bs-popper="static">
  <li class="dropdown-item-menu">
    <ul class="dropdown-submenu">
      <li>
        @if (
          reportingTabPermissions.viewPcpPosOvwPermission &&
          (reportingTabPermissions.viewPcpPosOvwPermission | checkPermissions)
          ) {
          <a
            routerLink="participant-positions-overview"
            routerLinkActive="active"
            class="dropdown-item"
            >Participant Positions Overview</a
            >
          }
        </li>
        <li>
          @if (
            reportingTabPermissions.viewPcpPosHistPermission &&
            (reportingTabPermissions.viewPcpPosHistPermission | checkPermissions)
            ) {
            <a
              routerLink="participant-positions-history"
              routerLinkActive="active"
              class="dropdown-item"
              >Participant Positions History</a
              >
            }
          </li>
          <li>
            @if (reportingTabPermissions.boPositionsOverviewViewPermission | checkPermissions) {
              <a
                class="dropdown-item text-wrap"
                routerLink="bo-positions-overview"
                routerLinkActive="active"
                >Beneficial Owner Positions Overview</a
                >
              }
            </li>
            <li>
              @if (reportingTabPermissions.boPositionsHistoryViewPermission | checkPermissions) {
                <a
                  routerLink="bo-positions-history"
                  class="dropdown-item text-wrap"
                  routerLinkActive="active"
                  >Beneficial Owner Positions History</a
                  >
                }
              </li>
            </ul>
          </li>

          <li class="dropdown-item-menu">
            <ul class="dropdown-submenu">
              <li>
                @if (
                  reportingTabPermissions.viewSPRPermission &&
                  (reportingTabPermissions.viewSPRPermission | checkPermissions)
                  ) {
                  <a
                    routerLink="security-position-reports"
                    routerLinkActive="active"
                    class="dropdown-item"
                    >Security Position Reports (SPR)</a
                    >
                  }
                </li>
              </ul>
            </li>

            <li class="dropdown-item-menu">
              <ul class="dropdown-submenu">
                <li>
                  @if (
                    reportingTabPermissions.viewPaymentMaturityReportsPermission &&
                    (reportingTabPermissions.viewPaymentMaturityReportsPermission | checkPermissions)
                    ) {
                    <a
                      routerLink="payment-reports"
                      routerLinkActive="active"
                      class="dropdown-item"
                      >Payment &amp; Maturity Reporting</a
                      >
                    }
                  </li>
                  <li>
                    @if (
                      reportingTabPermissions.viewTaxLiabilitiesPermission &&
                      (reportingTabPermissions.viewTaxLiabilitiesPermission | checkPermissions)
                      ) {
                      <a
                        routerLink="tax-liabilities"
                        routerLinkActive="active"
                        class="dropdown-item"
                        >Tax Liabilities, Debits &amp; Credits</a
                        >
                      }
                    </li>
                  </ul>
                </li>

                <li class="dropdown-item-menu">
                  <ul class="dropdown-submenu">
                    <li>
                      @if (
                        reportingTabPermissions.viewSanctionsRawFilesPermission &&
                        (reportingTabPermissions.viewSanctionsRawFilesPermission | checkPermissions)
                        ) {
                        <a
                          routerLink="sanctions-files"
                          routerLinkActive="active"
                          class="dropdown-item"
                          >Sanctions Raw Files</a
                          >
                        }
                      </li>
                      <li>
                        @if (
                          reportingTabPermissions.viewSanctionsRawFilesPermission &&
                          (reportingTabPermissions.viewSanctionsRawFilesPermission | checkPermissions)
                          ) {
                          <a
                            routerLink="sanctions-results"
                            routerLinkActive="active"
                            class="dropdown-item"
                            >Sanction Screening Results</a
                            >
                          }
                        </li>
                      </ul>
                    </li>

                    <li class="dropdown-item-menu">
                      <ul class="dropdown-submenu">
                        <li>
                          @if (
                            reportingTabPermissions.viewComplianceReportingSogeiPermission &&
                            (reportingTabPermissions.viewComplianceReportingSogeiPermission | checkPermissions)
                            ) {
                            <a
                              routerLink="compliance-reports-sogei"
                              routerLinkActive="active"
                              class="dropdown-item"
                              >Compliance Reporting - SOGEI</a
                              >
                            }
                          </li>
                        </ul>
                      </li>
                    </ul>
